import { useEffect, useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const dotX = useMotionValue(-100);
  const dotY = useMotionValue(-100);
  const ringX = useSpring(dotX, { stiffness: 220, damping: 26, mass: 0.4 });
  const ringY = useSpring(dotY, { stiffness: 220, damping: 26, mass: 0.4 });
  const ringRef = useRef(null);

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;

    const move = (e) => {
      dotX.set(e.clientX);
      dotY.set(e.clientY);
    };
    const enter = () => ringRef.current?.classList.add("hovering");
    const leave = () => ringRef.current?.classList.remove("hovering");

    window.addEventListener("mousemove", move);
    const interactives = () =>
      document.querySelectorAll(
        'a, button, [role="button"], input[type="submit"], .u-link, [data-cursor="hover"]'
      );
    const bind = () => {
      interactives().forEach((el) => {
        el.addEventListener("mouseenter", enter);
        el.addEventListener("mouseleave", leave);
      });
    };
    const unbind = () => {
      interactives().forEach((el) => {
        el.removeEventListener("mouseenter", enter);
        el.removeEventListener("mouseleave", leave);
      });
    };
    bind();
    const mo = new MutationObserver(() => {
      unbind();
      bind();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => {
      window.removeEventListener("mousemove", move);
      unbind();
      mo.disconnect();
    };
  }, [dotX, dotY]);

  return (
    <>
      <motion.div
        className="cursor-dot"
        style={{
          x: dotX,
          y: dotY,
          translateX: "-50%",
          translateY: "-50%",
        }}
        data-testid="cursor-dot"
      />
      <motion.div
        ref={ringRef}
        className="cursor-ring"
        style={{
          x: ringX,
          y: ringY,
          translateX: "-50%",
          translateY: "-50%",
        }}
        data-testid="cursor-ring"
      />
    </>
  );
}
